import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {ProductBuyReserveButton} from 'modules/product-card/components/ProductBuyReserveButton';
import {ProductBuyStickyCart} from 'modules/product-card/components/ProductBuyStickyCart';
import {selectProductData} from 'modules/product-card/selectors';
import {FC, useCallback} from 'react';
import {ProductShowSimilarButton} from 'modules/product-card/components/ProductShowSimilarButton';
import {Button} from 'components/Button';
import {Typography} from 'components/Typography';
import {showModal} from 'modules/modals/thunks';
import {MODALS} from 'modules/modals/constants';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';

export const ProductBuySticky: FC = () => {
    const productData = useAppSelector(selectProductData);
    const {canBuy, canReserve, similar} = productData || {};
    const dispatch = useAppDispatch();

    const handleClick = useCallback(() => {
        dispatch(showModal(MODALS.PRODUCT_NOTIFY_AVAILABLE.name));
    }, [dispatch]);

    if (canBuy) {
        return <ProductBuyStickyCart />;
    }

    if (canReserve) {
        return <ProductBuyReserveButton isSticky={true} />;
    }

    if (similar) {
        return <ProductShowSimilarButton />;
    }

    if (!canReserve || !canBuy) {
        return (
            <Button isStretched={true} onClick={handleClick} theme={'secondary'}>
                <Typography variant={'label-16-r'}>Узнать о наличии</Typography>
            </Button>
        );
    }

    return null;
};
